import React from 'react';

const SettingsSelect = ({ label, value, onChange, options, className = '' }) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-label mb-2">
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-dark-input border border-dark-border text-primary rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-carmin"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SettingsSelect;
